class TabsElement extends HTMLElement {
  connectedCallback() {
    this._tablist = this.querySelector('[role="tablist"]');
    this._tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this._panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this._activeIndex = this._tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
    if (this._activeIndex < 0) {
      this._activeIndex = 0;
    }

    this._controller = new AbortController();
    const { signal } = this._controller;

    this._activateTab(this._activeIndex, { focus: false });

    this._tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this._activateTab(index, { focus: true }), { signal });
    });

    this._tablist.addEventListener('keydown', (e) => this._onKeydown(e), { signal });
  }

  disconnectedCallback() {
    this._controller?.abort();
  }

  _onKeydown(e) {
    const lastIndex = this._tabs.length - 1;

    let nextIndex = null;
    switch (e.key) {
      case 'ArrowRight':
        nextIndex = (this._activeIndex + 1) % this._tabs.length;
        break;
      case 'ArrowLeft':
        nextIndex = (this._activeIndex - 1 + this._tabs.length) % this._tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = lastIndex;
        break;
      default:
        return;
    }

    e.preventDefault();
    this._activateTab(nextIndex, { focus: true });
  }

  _activateTab(index, { focus } = { focus: false }) {
    if (index < 0 || index >= this._tabs.length) {
      return;
    }

    this._activeIndex = index;

    this._tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === index;
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1; // Roving tabindex.
    });

    this._panels.forEach((panel, panelIndex) => {
      panel.setAttribute('aria-hidden', String(panelIndex !== index));
    });

    if (focus) {
      this._tabs[index]?.focus();
    }
  }
}

customElements.define('chh-tabs', TabsElement);

export default TabsElement;
